import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import { startCase, isArray, isEmpty, chain } from 'lodash';
import BackButton from '@/components/BackButton.vue';
const archetypeModule = namespace('archetypes');
let CharactersArchetypes = class CharactersArchetypes extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.defaultClass = '';
        this.className = '';
        this.tableType = 'Archetypes';
    }
    created() {
        this.fetchArchetypes();
        this.initialSearch = this.$route.query.search;
        const defClass = this.$route.query.class;
        this.defaultClass = startCase((isArray(defClass) ? defClass[0] : defClass) || undefined);
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return chain(this.archetypes)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(archetype => ({
            ...archetype,
            casterTypes: [archetype.classCasterType, archetype.casterType].filter(casterType => casterType && (casterType !== 'None')),
            to: `/${page}/archetypes/${encodeURIComponent(archetype.name)}`
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name',
                render: (name) => name.replace(/\ufffd/g, '-')
            },
            {
                text: 'Class',
                value: 'className',
                filterChoices: ['Berserker', 'Consular', 'Engineer', 'Fighter', 'Guardian', 'Monk', 'Operative', 'Scholar', 'Scout', 'Sentinel'],
                filterDefault: this.defaultClass,
                filterFunction: ({ className }, filterValue) => className === filterValue
            },
            {
                text: 'Caster Type',
                value: 'casterTypes',
                isMultiSelect: true,
                render: (casterTypes) => casterTypes.join(', ') || 'None',
                filterChoices: ['Tech', 'Force', 'None'],
                filterFunction: ({ casterTypes }, filterValue) => casterTypes.some(casterType => filterValue.includes(casterType)) ||
                    (filterValue.includes('None') && isEmpty(casterTypes))
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: startCase,
                filterChoices: ['PHB', 'EC'],
                filterFunction: ({ contentSource }, filterValue) => startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    archetypeModule.State
], CharactersArchetypes.prototype, "archetypes", void 0);
__decorate([
    archetypeModule.Action
], CharactersArchetypes.prototype, "fetchArchetypes", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersArchetypes.prototype, "isInHandbook", void 0);
CharactersArchetypes = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton
        }
    })
], CharactersArchetypes);
export default CharactersArchetypes;
